import { render, staticRenderFns } from "./XTOption.vue?vue&type=template&id=1ae4badb&scoped=true&"
import script from "./XTOption.vue?vue&type=script&lang=js&"
export * from "./XTOption.vue?vue&type=script&lang=js&"
import style0 from "./XTOption.vue?vue&type=style&index=0&id=1ae4badb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4badb",
  null
  
)

component.options.__file = "XTOption.vue"
export default component.exports